// import React, { useEffect, useRef, useState, useCallback } from "react";
// import SpareCard from "./SpareCard";
// import DropdownPickerText from "./DropdownPickerText";
// import { api } from "./localVariableFunction";
// import Navbar from "./../Header&Footer/Navbar";
// import "./SparePriceList.css"; // ✅ CSS import

// const SparePriceList = ({ userRole }) => {
//   const [groupedSpares, setGroupedSpares] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [productList, setProductList] = useState([]);
//   const [product, setProduct] = useState("");
//   const [srValue, setSrValue] = useState("");
//   const [srSpareList, setSrSpareList] = useState([]);
//   const [searchLoading, setSearchLoading] = useState(false);

//   const searchIdRef = useRef(0);

//   // ✅ Fetch Products + Spares
//   const fetchSpares = useCallback(async () => {
//     try {
//       const res = await api.get(`/api/sparepriceha`);
//       const resPdt = await api.get(`/api/sparepriceha/products`);

//       setProductList(resPdt.data || []);

//       const spares = res.data || [];
//       const grouped = spares.reduce((acc, item) => {
//         const productName = item.product;
//         if (!acc[productName]) acc[productName] = [];
//         acc[productName].push(item);
//         return acc;
//       }, {});

//       setGroupedSpares(
//         Object.keys(grouped).map((name) => ({ name, spares: grouped[name] }))
//       );
//     } catch (err) {
//       console.error("Spare fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchSpares();
//   }, [fetchSpares]);

//   // ✅ Search function
//   const fetchSearchItems = async (raw) => {
//     const searchValue = (raw || "").trim();
//     const myId = ++searchIdRef.current;

//     if (searchValue === "") {
//       setSearchLoading(false);
//       setSrSpareList([]);
//       return;
//     }

//     try {
//       setSearchLoading(true);
//       const resCalls = await api.get(`/api/sparepriceha/searchSpares`, {
//         params: { searchValue, product },
//       });
//       if (myId === searchIdRef.current) {
//         setSrSpareList(resCalls.data || []);
//       }
//     } catch (error) {
//       console.error("Error fetching spares:", error);
//     } finally {
//       if (myId === searchIdRef.current) setSearchLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <p className="loader-text">Loading Spares...</p>
//         {[...Array(4)].map((_, i) => (
//           <div key={i} className="loader-skeleton" />
//         ))}
//       </div>
//     );
//   }

//   const isSearchActive = srValue.trim().length > 0;

//   return (
//     <>
//       <Navbar />
//       <div className="spare-container">
//       <h1>Spare Part Pricing </h1>
      
//         {/* 🔍 Search Section */}
//         <div className="search-bar">
//           <span className="search-label">Search</span>
//           <DropdownPickerText
//             options={[
//               { label: "N/A - Select Product", value: "" },
//               ...productList.map((e, i) => ({
//                 label: `${i + 1}. ${e.haProductFn || e.productName || e.name}`,
//                 value: e.haProductFn || e.productName || e.name,
//               })),
//             ]}
//             selectedValue={product}
//             onSelect={(value) => {
//               setProduct(value);
//               if (srValue.trim().length > 0) fetchSearchItems(srValue);
//             }}
//           />
//           <div className="search-input-container">
//             <input
//               className="search-input"
//               value={srValue}
//               placeholder="Type Spare or Code"
//               onChange={(e) => {
//                 setSrValue(e.target.value);
//                 fetchSearchItems(e.target.value);
//               }}
//             />
//             {searchLoading && <span className="loading-text">Loading...</span>}
//           </div>
//         </div>

//         {/* 🔍 Search Results */}
//         {isSearchActive ? (
//           <div className="spare-list">
//             {srSpareList.map((item, idx) => (
//               <SpareCard
//                 key={`sr-${idx}`}
//                 {...item}
//                 userRole={userRole}
//                 refresh={fetchSpares}
//                 urlRole="online"
//               />
//             ))}
//           </div>
//         ) : (
//           <div className="spare-groups-wrapper">
//             {groupedSpares.map((group, idx) => (
//               <div key={idx} className="spare-group">
//                 <p className="group-title">
//                   {group.name} Spares ({group.spares.length})
//                 </p>
//                 <div className="spare-list">
//                   {group.spares.map((item, i) => (
//                     <SpareCard
//                       key={`${group.name}-${i}`}
//                       {...item}
//                       userRole={userRole}
//                       refresh={fetchSpares}
//                       urlRole="online"
//                     />
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default SparePriceList;


// import React, { useEffect, useRef, useState, useCallback } from "react";
// import SpareCard from "./SpareCard";
// import DropdownPickerText from "./DropdownPickerText";
// import { api } from "./localVariableFunction";
// import Navbar from "./../Header&Footer/Navbar";
// import "./SparePriceList.css";

// const SparePriceList = ({ userRole }) => {
//   const [groupedSpares, setGroupedSpares] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [productList, setProductList] = useState([]);
//   const [product, setProduct] = useState("");
//   const [srValue, setSrValue] = useState("");
//   const [srSpareList, setSrSpareList] = useState([]);
//   const [searchLoading, setSearchLoading] = useState(false);

//   const searchIdRef = useRef(0);

//   // ✅ Fetch Spares + Products
//   const fetchSpares = useCallback(async () => {
//     try {
//       const res = await api.get(`/api/sparepriceha`);
//       const resPdt = await api.get(`/api/sparepriceha/products`);

//       const spares = res.data || [];
//       setProductList(resPdt.data || []);

//       const grouped = spares.reduce((acc, item) => {
//         const productName = item.product;
//         if (!acc[productName]) acc[productName] = [];
//         acc[productName].push(item);
//         return acc;
//       }, {});

//       setGroupedSpares(
//         Object.keys(grouped).map((name) => ({
//           name,
//           spares: grouped[name],
//         }))
//       );
//     } catch (err) {
//       console.error("Spare fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchSpares();
//   }, [fetchSpares]);

//   // ✅ Search function
//   const fetchSearchItems = async (raw) => {
//     const searchValue = (raw || "").trim();
//     const myId = ++searchIdRef.current;

//     if (searchValue === "") {
//       setSearchLoading(false);
//       setSrSpareList([]);
//       return;
//     }

//     try {
//       setSearchLoading(true);
//       const resCalls = await api.get(`/api/sparepriceha/searchSpares`, {
//         params: { searchValue, product },
//       });

//       if (myId === searchIdRef.current) {
//         setSrSpareList(resCalls.data || []);
//       }
//     } catch (error) {
//       console.error("Error fetching Spares:", error);
//     } finally {
//       if (myId === searchIdRef.current) setSearchLoading(false);
//     }
//   };

//   // ✅ Loading state
//   if (loading) {
//     return (
//       <div style={{ padding: 10 }}>
//         <p style={{ fontSize: 16, fontWeight: 600 }}>Loading Spares...</p>
//         {[...Array(4)].map((_, i) => (
//           <div
//             key={i}
//             style={{
//               height: 180,
//               background: "#eee",
//               margin: "8px 0",
//               borderRadius: 10,
//             }}
//           />
//         ))}
//       </div>
//     );
//   }

//   const isSearchActive = srValue.trim().length > 0;

//   return (
//     <>
//       <Navbar />
//       <div className="spare-container">
//         {/* 🔍 Search Section */}
//         <div className="search-bar">
//           <span className="search-label">Search</span>
//           <DropdownPickerText
//             options={[
//               { label: "N/A - Select Product", value: "" },
//               ...productList.map((e, i) => ({
//                 label: `${i + 1}. ${e.haProductFn || e.productName || e.name}`,
//                 value: e.haProductFn || e.productName || e.name,
//               })),
//             ]}
//             selectedValue={product}
//             onSelect={(value) => {
//               setProduct(value);
//               if (srValue.trim().length > 0) fetchSearchItems(srValue);
//             }}
//           />

//           <div className="search-input-container">
//             <input
//               className="search-input"
//               value={srValue}
//               placeholder="Type Spare or Code"
//               onChange={(e) => {
//                 setSrValue(e.target.value);
//                 fetchSearchItems(e.target.value);
//               }}
//             />
//             {searchLoading && (
//               <span className="loading-text">Loading...</span>
//             )}
//           </div>
//         </div>

//         {/* 🔍 Search Results */}
//         {isSearchActive ? (
//           <div className="spare-list">
//             {srSpareList.length === 0 && !searchLoading ? (
//               <p style={{ textAlign: "center", marginTop: 10 }}>
//                 No results found
//               </p>
//             ) : (
//               srSpareList.map((item, idx) => (
//                 <SpareCard
//                   key={`sr-${idx}`}
//                   {...item}
//                   code={item.spareCode}
//                   userRole={userRole}
//                   refresh={fetchSpares}
//                   urlRole="online"
//                 />
//               ))
//             )}
//           </div>
//         ) : (
//           <div className="spare-groups-wrapper">
//             {groupedSpares.map((group, index) => (
//               <div key={index} className="spare-group">
//                 <p className="group-title">
//                   {group.name} Spare List ({group.spares.length})
//                 </p>
//                 <div className="spare-list">
//                   {group.spares.map((item, i) => (
//                     <SpareCard
//                       key={`${group.name}-${i}`}
//                       {...item}
//                       code={item.spareCode}
//                       userRole={userRole}
//                       refresh={fetchSpares}
//                       urlRole="online"
//                     />
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default SparePriceList;
import React, { useEffect, useRef, useState, useCallback } from "react";
import SpareCard from "./SpareCard";
import DropdownPickerText from "./DropdownPickerText";
import { api } from "./localVariableFunction";
import Navbar from "./../Header&Footer/Navbar";
import "./SparePriceList.css";

const SparePriceList = ({ userRole }) => {
  const [groupedSpares, setGroupedSpares] = useState([]);
  const [loading, setLoading] = useState(true);

  const [productList, setProductList] = useState([]);
  const [product, setProduct] = useState("");
  const [srValue, setSrValue] = useState("");
  const [srSpareList, setSrSpareList] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const searchIdRef = useRef(0);

  const fetchSpares = useCallback(async () => {
    try {
      const res = await api.get(`/api/sparepriceha`);
      const resPdt = await api.get(`/api/sparepriceha/products`);

      setProductList(resPdt.data || []);
      const spares = res.data || [];

      const grouped = spares.reduce((acc, item) => {
        const productName = item.product;
        if (!acc[productName]) acc[productName] = [];
        acc[productName].push(item);
        return acc;
      }, {});

      setGroupedSpares(
        Object.keys(grouped).map((name) => ({ name, spares: grouped[name] }))
      );
    } catch (err) {
      console.error("Spare fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSpares();
  }, [fetchSpares]);

  const fetchSearchItems = async (raw) => {
    const searchValue = (raw || "").trim();
    const myId = ++searchIdRef.current;

    if (searchValue === "") {
      setSearchLoading(false);
      setSrSpareList([]);
      return;
    }

    try {
      setSearchLoading(true);
      const resCalls = await api.get(`/api/sparepriceha/searchSpares`, {
        params: { searchValue, product },
      });
      if (myId === searchIdRef.current) {
        setSrSpareList(resCalls.data || []);
      }
    } catch (error) {
      console.error("Error fetching spares:", error);
    } finally {
      if (myId === searchIdRef.current) setSearchLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <p className="loader-text">Loading Spares...</p>
        {[...Array(4)].map((_, i) => (
          <div key={i} className="loader-skeleton" />
        ))}
      </div>
    );
  }

  const isSearchActive = srValue.trim().length > 0;

  return (
    <>
      <Navbar />
      <div className="spare-container"> 
        

        <div className="search-bar">
           {/* <h1>Spare Part Pricing</h1> */}
          <span className="search-label"> </span>
          <DropdownPickerText
            options={[
              { label: "Select Product", value: "" },
              ...productList.map((e, i) => ({
                label: `${i + 1}. ${e.haProductFn || e.productName || e.name}`,
                value: e.haProductFn || e.productName || e.name,
              })),
            ]}
            selectedValue={product}
            onSelect={(value) => {
              setProduct(value);
              if (srValue.trim().length > 0) fetchSearchItems(srValue);
            }}
          />
          <div className="search-input-container">
            <input
              className="search-input"
              value={srValue}
              placeholder="Type Spare or Code"
              onChange={(e) => {
                setSrValue(e.target.value);
                fetchSearchItems(e.target.value);
              }}
            />
            {searchLoading && <span className="loading-text">Loading...</span>}
          </div>
        </div>

        {/* Search Result or Group Display */}
        {isSearchActive ? (
          <div className="spare-list vertical-scroll">
            {srSpareList.map((item, idx) => (
              <SpareCard
                key={`sr-${idx}`}
                {...item}
                code={item.spareCode}
                userRole={userRole}
                refresh={fetchSpares}
                urlRole="online"
              />
            ))}
          </div>
        ) : (
          <div className="spare-groups-wrapper">
            {groupedSpares.map((group, index) => (
              <div key={index} className="spare-group">
                <p className="group-title">
                  {group.name} Spares ({group.spares.length})
                </p>
                <div className="spare-list vertical-scroll">
                  {group.spares.map((item, i) => (
                    <SpareCard
                      key={`${group.name}-${i}`}
                      {...item}
                      code={item.spareCode}
                      userRole={userRole}
                      refresh={fetchSpares}
                      urlRole="online"
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SparePriceList;
